import Cropper from 'cropperjs';

export function ImageUploaderViewModel(data) {
	var self = this;
	self.type= "ImageUploaderViewModel"

	self.rootvm = data.rootvm;

	self.initialized = ko.observable(false);
	self.initialize = function() {
		if (!self.initialized()){
			// get all available tags
			self.is_busy(true);
			self.get_tags();
			self.initialized(true);
		}
	}

	self.afterHide = function() {
		if (self.initialized()){
			self.initialized(false);
		}
	}

	self.is_busy = ko.observable(false);

	// image variables
	self.dropping_file = ko.observable(false);
	self.file = ko.observable(undefined);
	self.file.subscribe(function (fileObj) {
		if (!self.filename()) {
			self.filename(fileObj.name.slice(0,fileObj.name.lastIndexOf(".")));
		}
	});
	self.cropper = ko.observable();

	// meta data
	self.date_prefix = (new Date).toISOString().slice(0,10).replaceAll("-","") + "_";
	self.filename = ko.observable(undefined);
	self.filename.subscribe(function (newName) {
		if (newName) {
			self.filename(newName
				.toLowerCase()
				.replace(/\s/g, '_')
				.replace(/(\u00e4|ä)/g, 'ae')
				.replace(/(\u00f6|ö)/g, 'oe')
				.replace(/(\u00fc|ü)/g, 'ue')
				.replace(/(\u00df|ß)/g, 'ss')
				.replace(/[^a-z0-9_-]/g, '')
			);
		}
	});
	self.description = ko.observable();
	self.aspect_ratio = ko.observable(3/2);
	self.extra_notes = ko.observable();
	self.tags = ko.observableArray([]);

	self.example_show = ko.observable(false);
	self.example_image = ko.pureComputed(function () {
		return '<Image params"img: \'' + self.date_prefix + self.filename() + '\', alt: \'' + self.description() + '\'"></Image>';
	});
	self.example_header_image = ko.pureComputed(function () {
		return '{% set img_src=\'' + self.date_prefix + self.filename() + '\' %}\n' +
		'{% set img_position=\'CHOOSE top, center, bottom\' %}\n{% set headline=\'' + self.description() + '\' %}\n' +
		'{% set subline= \'ADD TEXT HERE\' %}\n' +
		'{% include \'static/js-modules/jinja-templates/header-image.html\' with context %}';
	});
	self.example_tile = ko.pureComputed(function () {
		return 'image: \'' + self.date_prefix + self.filename() + '\',\n' +
			'title: \'' + self.description() + '\',';
	});
	self.example_image_tile = ko.pureComputed(function () {
		return 'image: \'' + self.date_prefix + self.filename() + '\',\n' +
			'alt: \'' + self.description() + '\',';
	});
	self.example_meta_img = ko.pureComputed(function () {
		return '\"meta_image\" \: \"' + self.date_prefix + self.filename() + '\"';
	});
	// upload
	self.upload_progress = ko.observable(0);
	self.is_uploading = ko.observable(false);
	self.error = ko.observable();

	// Uploads
	self.image_processing = function(me, evt){
		for(let i = 0; i < evt.target.files.length; i++)
		{
			self.file(self.read_local_source(evt.target.files[i]));
		}

		const image = document.getElementById('image-to-upload');
		self.cropper(new Cropper(image, {
			aspectRatio: self.aspect_ratio(),
			viewMode: 1,
			zoomable: false,
			autoCropArea: 1,
			cropend() {
				self.setCroppedImageSize();
			},
			ready() {
				self.setCroppedImageSize();
			},
		}));
		self.dropping_file(false);
	};

	self.cropped_img_size = ko.observable(undefined);
	self.setCroppedImageSize = function () {
		var url = self.cropper().getCroppedCanvas().toDataURL('image/jpeg', 0.85);

		fetch(url)
		.then(res => res.blob())
		.then(blob => {
			self.cropped_img_size(blob.size);
		})
	}

	self.xhr_with_progress = function() {
		var xhr = new window.XMLHttpRequest();
		xhr.upload.addEventListener("progress",
			function(evt) {
				if (!evt.lengthComputable) return;
				var percentComplete = (evt.loaded / evt.total) * 100;
				self.upload_progress(Math.round(percentComplete) + '%');
			}, false);
		return xhr;
	};

	self.read_local_source = function(file) {
		// TODO We might not want to do this if the
		// file is too large...
		var f = {
			'name': file.name,
			'type': file.type,
			'size': file.size,
			//'reading_progress': reading_progress
		}
		var fr = new FileReader();
		//First read as data url
		fr.onload = function (file_data) {
			//Make thumbnail show up
			self.cropper().replace(file_data.target.result);
			f.data = file_data.target.result.split(',').pop();
		}
		fr.readAsDataURL(file);
		return f;
	};

	self.upload_file = function () {
		self.is_uploading(true);
		return $.ajax({
			xhr: self.xhr_with_progress,
			url: '/api/tools/image-upload',
			type: 'POST',
			data:ko.toJSON({
				filename: self.date_prefix + self.filename(),
				description: self.description(),
				uploaded_by: scvm.webapp_session().user().person_uuid(),
				cropped_img_data: self.cropper().getCroppedCanvas().toDataURL('image/jpeg', 1.0).split(',').pop(),
				tags: self.tags(),
				extra_notes: self.extra_notes()
			}),
			contentType: "application/json; charset=utf-8",
			processData: false,
			success: function (data) {

				self.is_uploading(false);
				if(data.success){
					self.example_show(true);
					notyf.success(data.message);
				}
				else{
					console.error('An error has occurred!', data.message);
					notyf.error(data.message);
				}
			},
			error: function (data) {
				console.error('An error has occurred!', data);
				notyf.error(data.responseText);
			}
		});
	};

	self.image_delete = function() {
		self.example_show(false);

		self.cropper().destroy();
		self.file(undefined);

		self.filename(undefined);
		self.description(undefined);
		self.extra_notes(undefined);
		self.tags([]);
	}

	self.image_upload = function () {
		self.is_busy(true);
		self.is_uploading(true);
		self.upload_file();
		self.is_busy(false);
	}

	// tags helper
	self.tags_joined = ko.pureComputed(function () {
		return self.tags().length ? self.tags().join() : "";
	})
	self.new_tag = ko.observable(undefined);
	self.available_tags = ko.observableArray();
	self.add_new_tag = function() {
		if (self.new_tag()) {
			self.available_tags.push(self.new_tag());
			self.tags.push(self.new_tag());
			self.new_tag(undefined);
		}
	}

	self.get_tags = function () {
		return $.ajax({
			url: '/api/tools/image-tags',
			type: 'GET',
			cache: true,
			contentType: "text/json; charset=utf-8",
			success: function (data) {
				self.available_tags(data.tags);
			},
			complete: function () {
				self.is_busy(false);
			}
		});
	}
}
